export default class Reclamacion{
		public cod_usuario: string = "";
        public id_rnc: string = "";
        public razon_social: string = "";
        public cod_empresa_cta: string = "";
        public cod_cuenta: string = "";
        public tipo_fondo: string = "";
        public email_usuario: string = "";
        public code_tel_casa: string = "";
        public tel_residencia: string = "";
        public code_tel_celular: string = "";
        public tel_celular: string = "";
        public dir_permanente1: string = "";
        public des_domicilio1: string = "";
        public des_edificio1: string = "";
        public des_apto1: string = "";
        public cod_ciudad1: string = "";
        public cod_sector1: string = "";
        public ciudad1: string = "";
        public sector1: string = "";
        public dir_permanente2: string = "";
        public des_domicilio2: string = "";
        public des_edificio2: string = "";
        public des_apto2: string = "";
        public cod_ciudad2: string = "";
        public cod_sector2: string = "";
        public ciudad2: string = "";
        public sector2: string = "";
        public cod_cargo: string = "";
        public ind_estado: string = "";
        public tip_gestion: string = "";
        public observacion: string = "";
        public ind_via_respuesta: string = "";
        public ind_via_recepcion: string = "";
        public cod_persona: string = "";
        public id_nss: string = "";
        public ip_cliente: string = "";
}
